import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// eslint-disable-next-line global-require
const dynamicComponentPreviewGrid = () => require("%/dynamic-component-editor/inspector/Inspector-elements/DynamicComponentPreviewGrid.vue").default;
// eslint-disable-next-line global-require
const useDynamicComponentStore = (...args) => require("%/dynamic-component-editor/stores/dynamic-component-store").default(...args);
// eslint-disable-next-line global-require
const useDynamicComponentEditorStore = (...args) => require("%/dynamic-component-editor/stores/dynamic-component-editor").default(...args);


export default class TemplateType extends BaseOption {
  static userInterfaceComponent = optionValues => {
    const options = this.getTemplateOptions(optionValues);

    return {
      label: "Variation",
      component: inspectorTools.ARROW_PICKER,
      useVerticalOrientation: true,
      props: {
        options,
        useBrowsingModal: true,
        browsingModalTitle: "Browse Variants",
        browsingModalTooltip: "Browse Variants",
        browsingComponent: dynamicComponentPreviewGrid(),
        sideEffect: (value, identifier) => {
          const editorStore = useDynamicComponentEditorStore();
          editorStore.dynamicComponentInstance.switchTemplateForElement(
            identifier,
            value,
          );
        },
      },
    };
  };

  static defaultValue = "";

  static getTemplateTypeId(optionValues) {
    return optionValues?.["default.template-type"];
  }

  static getTemplateTypeConfig(templateTypeId) {
    if (!templateTypeId) {
      return null;
    }
    const components = {
      ...useDynamicComponentStore().dynamicComponents,
      ...useDynamicComponentStore().parentDynamicComponents,
    };
    return components[templateTypeId];
  }

  static getTemplateType(templateTypeConfig) {
    if (!templateTypeConfig) {
      return null;
    }
    return templateTypeConfig.rootOptions["template-type"];
  }

  static getAllTemplatesOfType(templateType) {
    if (!templateType) {
      return [];
    }
    const allConfigs = [
      ...Object.values(useDynamicComponentStore().dynamicComponents),
      ...Object.values(useDynamicComponentStore().parentDynamicComponents),
    ];
    return allConfigs.filter(config => {
      const rootOptions = config.rootOptions ?? {};
      return rootOptions["template-type"] === templateType;
    });
  }

  static mapTemplateConfigsToOptions(templateConfigs) {
    return templateConfigs.map(templateConfig => ({
      id: templateConfig.dynamic_component_id,
      name: templateConfig.rootOptions["display-name"] || templateConfig.rootOptions["component-name"] || templateConfig.name,
      data: templateConfig,
    }));
  }

  static getTemplateOptions(optionValues) {
    const templateTypeId = this.getTemplateTypeId(optionValues);
    const templateTypeConfig = this.getTemplateTypeConfig(templateTypeId);
    const templateType = this.getTemplateType(templateTypeConfig);
    const allTemplatesOfType = this.getAllTemplatesOfType(templateType);
    return this.mapTemplateConfigsToOptions(allTemplatesOfType);
  }
}
